import { ReactNode, forwardRef, ReactElement, Ref } from "react";
import { TransitionProps } from "@mui/material/transitions";
import {
  Dialog,
  Slide,
  Stack,
  Box,
  Card,
  Typography,
  useTheme,
  useMediaQuery,
  IconButton,
  Button,
} from "@mui/material";
import {
  mobileCardSx,
  cardHeaderSx,
  cardSx,
  AUTURA_ASPHALT_LIGHT,
} from "utils";
import { Cancel } from "@mui/icons-material";
import { ImageListItemData } from "types";
import { useTranslation } from "react-i18next";
const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
interface PhotoViewerProps {
  open: boolean;
  image: ImageListItemData;
  close: () => void;
}

const PhotoViewer = ({ open, close, image }: PhotoViewerProps): ReactNode => {
  const { palette, breakpoints } = useTheme();
  const { t } = useTranslation();
  const mobile = useMediaQuery(breakpoints.down("lg"));

  return (
    <Dialog
      open={open}
      onClose={close}
      TransitionComponent={Transition}
      scroll={"body"}
      fullWidth
      aria-label={image.title}
      maxWidth={"lg"}
      fullScreen={mobile}
      sx={{ mt: { xs: -1, lg: 0 }, pb: 0 }}
    >
      <Card raised sx={mobile ? mobileCardSx : cardSx}>
        <Box
          sx={
            mobile
              ? {
                  display: "flex",
                  p: { xs: 2, sm: 4 },
                  backgroundColor: palette.secondary.main,
                  justifyContent: "space-between",
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                }
              : cardHeaderSx
          }
        >
          <Box sx={{ flex: 1, alignItems: "center", display: "flex" }}>
            <Typography
              variant={"h4"}
              sx={{
                color: palette.secondary.contrastText,
                textAlign: "left",
              }}
            >
              {image.title}
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 1,
              alignItems: "center",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <Button
              variant={"text"}
              onClick={close}
              sx={{
                px: 1,
                textTransform: "uppercase",
                color: palette.secondary.contrastText,
              }}
              endIcon={
                <Cancel
                  htmlColor={palette.secondary.contrastText}
                  fontSize={"large"}
                />
              }
            >
              {t("close")}
            </Button>
          </Box>
        </Box>
        <Box>
          <Stack
            direction={"column"}
            spacing={2}
            sx={{ alignItems: "center", justifyContent: "center" }}
          >
            <img
              src={image.img}
              alt={image.title}
              style={{
                width: "100%",
                height: "auto",
                borderRadius: 8,
                boxShadow: AUTURA_ASPHALT_LIGHT,
              }}
            />
          </Stack>
        </Box>
      </Card>
    </Dialog>
  );
};
export default PhotoViewer;
